import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";

interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

export default function setupFirebase() {
  let firebaseConfig: FirebaseConfig;
  if (import.meta.env.VITE_NODE_ENV === "development") {
    firebaseConfig = {
      apiKey: "AIzaSyCIIBy-9yc-Bj9XwEE1q3LjpH1aZzpigPk",
      authDomain: "salon-dev-c8d0f.firebaseapp.com",
      projectId: "salon-dev-c8d0f",
      storageBucket: "salon-dev-c8d0f.firebasestorage.app",
      messagingSenderId: "961568794066",
      appId: "1:961568794066:web:72450f5a93f1ed0c1f140b",
      measurementId: "G-L9641DBKP6",
    };
  } else {
    firebaseConfig = {
      apiKey: "AIzaSyBNKOxVK-Vk7rqZA-tnuESt1zV7QM_ZhcI",
      authDomain: "salon-796ed.firebaseapp.com",
      projectId: "salon-796ed",
      storageBucket: "salon-796ed.firebasestorage.app",
      messagingSenderId: "792629927518",
      appId: "1:792629927518:web:6b38192ec4d2716ff61ecf",
      measurementId: "G-S2GLKGWC00",
    };
  }

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  getAnalytics(app);
}
